
import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { BASE_URL } from '../Config/Base';

 const TcEditPopMain = () => {

  

    var checkname=localStorage.getItem('username')
    let EditData = JSON.parse(localStorage.getItem("EditData"));


    let userName = EditData.map((item) => item.userName);

    let UserName = userName[0]

    let email= EditData.map((item) => item.email);
    // let passwordHash=EditData.map((item) => item.passwordHash);

    let Email =email[0]
    let active= EditData.map((item) => item.active);

    let ActiveState = active[0]

    let id= EditData.map((item) => item.id)

    let Id= id[0]

    const token = JSON.parse(localStorage.getItem('usertoken'));


    function GeneratePassword() {

 
        var NewPass =Pass()+ '@123';
     
     
        console.log(NewPass)
        const body ={email: Email, newPassword:NewPass}
     
     
     axios({
          method: "POST",
          //url :`${BASE_URL}/tc/Generatepassword`,
          url:'https://localhost:44312/Api/Tc/Generatepassword',
           data:body, 
           headers: {
            "Content-Type": "application/json",
           
           }     
           }) 
           .then((response) =>{
             console.log(response.data);
           
           
            if(response.data.status === "Error"){
                
                 alert("InCorrect Password")
               }
           
               else if(response.data.status === "Success"){
                 document.getElementById("Gpass").innerHTML=NewPass;
                 //alert("Password Generated")
                 document.getElementById('pswedit-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('pswedit-notify').style.display = "none"
         },1000)

               }
             })
             .catch(error => {
               console.log(error);
               alert("failed !")
     
             })
     
      }
     
      const Allowed = {
         Uppers: "QWERTYUIOPASDFGHJKLZXCVBNM",
         Lowers: "qwertyuiopasdfghjklzxcvbnm",
        //  Numbers: "1234567890",
        //  Symbols: "!@#$%^&*"
     }
     
     const getRandomCharFromString = (str) => str.charAt(Math.floor(Math.random() * str.length))
     
     /**
      * the generated password will be @param length, which default to 8, 
      * and will have at least one upper, one lower, one number and one symbol
      * @param {number} length - password's length
      * @returns a generated password
      */
     const Pass = (length = 6) => {
         let pwd = "";
         pwd += getRandomCharFromString(Allowed.Uppers);  // pwd will have at least one upper
         pwd += getRandomCharFromString(Allowed.Lowers);  // pwd will have at least one lower
        //  pwd += getRandomCharFromString(Allowed.Numbers);  // pwd will have at least one number
        //  pwd += getRandomCharFromString(Allowed.Symbols); // pwd will have at least one symbol
         for (let i = pwd.length; i < length; i++)
             pwd += getRandomCharFromString(Object.values(Allowed).join(''));  // fill the rest of the pwd with random characters
         return pwd
     
        
     
     }


     const [Active, setActive] =useState(" ")

     ///function update

function updatetc(){
//var Security = document.getElementById("Gpassword").value


if(Active===0){

  var Action =0
 }
 else if(Active===1){
  var Action= 1

 }

 else{
    var Action=ActiveState

 }

// if(SPassword!=0){
    
//   var SecurityPass = SPassword
// }
// else{
//   var SecurityPass = Security

// }
  
// var Gpass = document.getElementById("Gpass").value;
var EditName = document.getElementById("EditName").value;


if(!EditName){
document.getElementById("ErrA").innerHTML="UserName Required"

}
else if(EditName){

  document.getElementById("ErrA").innerHTML=" "

  const body =
  {
    
    name:EditName, 
    id:Id,
    active:Action,
    normalizedUserName:EditName
   
 
  }
  console.log('body',body);


  axios({
         method:"POST",
         //url :`${BASE_URL}/tc/UpdateAspNetUser`,
         url: "https://localhost:44312/Api/Tc/UpdateTcUser",
         data:body, 
         headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer " + `${token}`,
          }     
      }) 

     .then((response) =>{
     console.log(response.data);


     if(response.data.status === "Success"){
    
        document.getElementById('edit-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('edit-notify').style.display = "none"
         },1000)
    
       // alert("updated")
          //localStorage.setItem("EditData",JSON.stringify(response.data))
       
      
          //localStorage.setItem('username',EditName);

          //  setActive(false)

          // setInActive(false)

          if(checkname===UserName){

            localStorage.setItem('username',EditName);
        }

          setTimeout(() => {
        
            window.location.href="/?#/Tcadduser"
            
          }, 1000);
        }


        

  })
  .catch(error => {
    console.log(error);
    alert("failed to Update")
   
  })
    

}
}

let edituser =   localStorage.getItem("EditData")
  let editusername =  JSON.parse(edituser);
  
  let USERNAME = editusername.map((e)=>e.userName);
  //console.log(USERNAME);

  const[Name, setName] =useState(USERNAME)
  console.log(Name)
  
  return (
    <div className='TC-addmain'>
   
       <div className="TC-addgrid-layout">
<div className="TC-addmain-top">
<div className='TC-addmain-back'>
<Link to='/Tcadduser'><i className="fa-sharp fa-solid fa-backward"></i></Link>
</div> 
<span>Edit User</span>
</div>
</div>

   {/* ---EditPopup ----*/}


   <div className="modal-dialog" role="document">
      <div className="Edit-Content">
      
   <form  id="edittcform" onSubmit={()=>updatetc()}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
       
          <input type="text" id="EditName" defaultValue={userName}   />
          <span id="ErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">

          <input type="text"  defaultValue={email} readOnly/>

          </div>
        <div className="md-form mb-5">
        {/* <input  value={passwordHash} id="Gpassword"/> */}
       {/* <input type="checkbox"   id="Generatcheck" onClick={ChangePassword}/>&nbsp; */}
          <span className='col-sm-7'  id="Generatetcbox" ><span id="Gpass">Password</span></span> 
         <button id="Generatetcbtn" className='col-sm-4' type='button' onClick={GeneratePassword} >Generate</button>
    
         </div>
        
<div className="md-form mb-3">

  


{ActiveState===0 ? 
    <center>
 <input type="checkbox" id="tcactiveswitch"
              className="Activecheckbox"   onChange={()=>setActive(1)}/>
  <label for="tcactiveswitch" className="tctoggleactive">
       

<p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


  </label>

  </center>
:
<center>
<input type="checkbox" id="tcinactiveswitch"
         class="InActivecheckbox"  onChange={()=> setActive(0)} />
<label for="tcinactiveswitch" className="tctoggleinactive">
  

<p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


</label>

</center>


     }
{/* <button id ='oatInActive-buttonB' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>InActive</button> */}


</div>


       
      </div>
      <div className="modal-footer d-flex justify-content-center" >
        <button type="submit" id="tceditpopbtn">Save Changes</button>
      </div>
      </form>

      <div className='TCpopfade' id='edit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Changes&nbsp; <span style={{color:"blue"}}>Updated</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
           
          </section> 
            
          
    </div>
  </div>
</div>
<div className='TCpopfade' id='pswedit-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
    <h6 class="notif-title" style={{color:"blue"}}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Name}'s</h6>
             <p>Password Generated </p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
           
             
           
          </section> 
            
          
    </div>
  </div>
</div>
    </div>
  </div>




</div>
  )
}
export default TcEditPopMain
